import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import LaunchProgress from '../launch-progress'
import LaunchStepCard from '../launch-step-card'
import styles from './styles'

const SECTION = 'launch'

/** "Create and launch your academy" guide. Always shown, even when done. */
const LaunchSection = ({ classes, steps, onAction }) => (
  <>
    <div className={classes.heading}>
      <h1 className={classes.title}>Create and launch your academy</h1>
      <div className={classes.subtitleRow}>
        <LaunchProgress steps={steps} />
        <span className={classes.subtitle}>
          Start anywhere. Nothing here is required.
        </span>
      </div>
    </div>

    <div className={classes.grid}>
      {steps.map(step => (
        <LaunchStepCard
          key={step.id}
          step={step}
          onAction={() =>
            onAction(step.action, { section: SECTION, itemId: step.id })
          }
        />
      ))}
    </div>
  </>
)

export default withStyles(styles)(LaunchSection)
